// Devuelve la librería de axios pero con todas las adaptaciones que necesitamos
// para la web de cifra como asignar el csrf, automatismos de cabeceras especiales etc.
import axios from 'axios';
import AxiosLoader from '@/libs/AxiosLoader';
import { useCifraClient } from '@/api/cifra-client';
import { showResponseMessages, redirectFromHeaders } from './flash';

// Errores estandar de cifra y flash messages
function addInterceptorMensajesRedirect(axiosInstance) {
  axiosInstance.interceptors.response.use((response) => {
    redirectFromHeaders(response);
    showResponseMessages(response);
    return response;
  }, (error) => {
    if (error.response) {
      // Los 302 entran por aquí también
      redirectFromHeaders(error.response);
      showResponseMessages(error.response);
    }
    return Promise.reject(error);
  });
}

// Configuración global de axios
const globalAxiosLoader = new AxiosLoader(axios);
const { cifraClient, configurar } = useCifraClient();

addInterceptorMensajesRedirect(axios);
addInterceptorMensajesRedirect(cifraClient);

function configurarTodo() {
  globalAxiosLoader.load();
  configurar();
}

document.addEventListener('turbo:load', () => {
  configurarTodo();
});

configurarTodo();

export default axios;
